export default __webpack_public_path__ + "103fba5eb2a03b6b4c66efd06f526980.svg";